const fieldType = {
    INPUT: "input",
    INPUT_MONEY: "input_money",
    TEXTAREA: "textarea",
    CHECKBOX: "checkbox",
    DROPDOWN: "dropdown",
    RADIO: "radio",
    HTML: "html",
    DATE_RANGE: "date_range",
    CHECKBOX_LIST: "checkbox_list",
    TERMS: "terms"
};

const inputType = {
    text: "text",
    password: "password",
    none: "",
    checkbox: "checkbox",
    radio: 'radio'
};

const FIELD_NAME = {
    user_type: 'user_type',
    name: 'name',
    name_kana: 'name_kana',
    postal_code: 'postal_code',
    address_province: 'address_province',
    address: 'address',
    return_invoice: 'return_invoice',
    return_certificate: 'return_certificate',
    amount: 'amount',
    publish: 'publish',
    agree: 'agree'
};

const fields = [
    {
        label: "個人・法人",
        name: FIELD_NAME.user_type,
        type: fieldType.RADIO,
        inputType: inputType.radio,
        required: true,
        options: [
            {
                id: 1,
                label: '個人',
                value: 0
            },
            {
                id: 2,
                label: '法人',
                value: 1
            }
        ]
    },
    {
        label: "お名前",
        name: FIELD_NAME.name,
        type: fieldType.INPUT,
        inputType: inputType.text,
        placeholder: "鈴木 花子",
        required: true,
    },
    {
        label: "ふりがな",
        name: FIELD_NAME.name_kana,
        type: fieldType.INPUT,
        inputType: inputType.text,
        placeholder: "すずき はなこ",
        required: true,
    },
    {
        label: "郵便番号",
        name: FIELD_NAME.postal_code,
        type: fieldType.INPUT,
        inputType: inputType.text,
        placeholder: "532-0011",
        required: true,
    },
    {
        label: "都道府県",
        name: FIELD_NAME.address_province,
        type: fieldType.DROPDOWN,
        placeholder: "大阪府",
        required: true,
    },
    {
        label: "住所",
        name: FIELD_NAME.address,
        type: fieldType.INPUT,
        inputType: inputType.text,
        placeholder: "大阪市東淀川区西中島４－６－７",
        required: true,
    },
    {
        label: "領収書",
        name: FIELD_NAME.return_invoice,
        type: fieldType.RADIO,
        inputType: inputType.radio,
        required: true,
        options: [
            {
                id: 2,
                label: '送付希望',
                value: 1
            },
            {
                id: 1,
                label: '送付不要',
                value: 0
            }
        ]
    },
    {
        label: "税額控除証明書",
        name: FIELD_NAME.return_certificate,
        type: fieldType.RADIO,
        inputType: inputType.radio,
        required: true,
        options: [
            {
                id: 2,
                label: '送付希望',
                value: 1
            },
            {
                id: 1,
                label: '送付不要',
                value: 0
            },
        ]
    },
    {
        label: "寄附金額",
        name: FIELD_NAME.amount,
        type: fieldType.INPUT_MONEY,
        inputType: inputType.text,
        placeholder: "100000",
        required: true,
    },
    {
        label_html: `<div>
            <div>ご寄附者名のホームページ等への掲載<span class="field-required">※</span>
            </div>
            <div>ニュースレター（当法人広報誌）およびホームページ</div>
        </div>`,
        name: FIELD_NAME.publish,
        type: fieldType.RADIO,
        inputType: inputType.radio,
        required: true,
        options: [
            {
                id: 1,
                label: '希望する',
                value: 1
            },
            {
                id: 2,
                label: '希望しない',
                value: 0
            }
        ]
    },
    {
        label: "個人情報の取り扱いについて※上記に含まれる個人情報には、ご意見・お問い合わせへの回答、サイトの向上のためだけに使用させていただくものとし、個人情報の収集・利用・管理については「プライバシーポリシー」に基づき適切に取り扱います。",
        type: fieldType.TERMS,
    },
    {
        label: "上記の「個人情報の取り扱いについて」をご確認の上、同意します。",
        name: FIELD_NAME.agree,
        type: fieldType.CHECKBOX,
        inputType: inputType.checkbox,
        required: true,
    },
];

const MODE_UI = {
    FORM: "form",
    PREVIEW: "preview",
};

module.exports = {
    fields,
    fieldType,
    FIELD_NAME,
    MODE_UI
}
